import React, {Component} from 'react'
import PrintSSTTaxInvoiceCoverNoteInsurer from '../sst/PrintSSTTaxInvoiceCoverNoteInsurer'

class PrintTLGTaxInvoiceCoverNoteInsurer extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  componentDidMount(){
    
  }

  render() {
    return(  
        <PrintSSTTaxInvoiceCoverNoteInsurer
            tivList={this.props.tivList}
            showTaxinvoice={true}
        />
    )    
  }
}

export default PrintTLGTaxInvoiceCoverNoteInsurer;


// WEBPACK FOOTER //
// ./src/view/print/tlg/PrintTLGTaxInvoiceCoverNoteInsurer.js